import axios from 'axios'
import {useEffect} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {API_URL} from 'src/cms/constants/EndPoint'
import {actions} from './redux/actions'
import {useDispatch, useSelector} from 'react-redux'
import * as auth from './redux/actions'
import {actionTypes} from './redux/constants'

const Callback = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const queryParams = new URLSearchParams(location.search)
  const code = queryParams.get('code')
  const state = queryParams.get('state')
  const iss = queryParams.get('iss')
  const stateKey = `oidc.${state}`
  const stateObj = JSON.parse(sessionStorage.getItem(stateKey) || '{}')
  const authResp = useSelector((state: any) => state.auth)
  const code_verifier = stateObj.code_verifier
  const redirect_url = window.__RUNTIME_CONFIG__.REACT_APP_REDIRECT_URL

  const payload = {
    code,
    state,
    iss,
    code_verifier,
    redirect_url,
  }
  useEffect(() => {
    axios
      .post(`${API_URL}/sso/login`, payload)
      .then((res) => {
        const token = res?.data?.data?.token
        // First dispatch login success to store the token
        dispatch({type: actionTypes.LOGIN_SUCCESS, payload: {accessToken: token}})
        // Then request user data
        dispatch(auth.actions.requestUser(token))
        // Navigate to dashboard after successful login
        navigate('/dashboard')
      })
      .catch((err) => {
        console.error('Login error:', err)
      })
  }, [])

  return <></>
}

export default Callback
